import React from "react";
import { AWS_File_URL } from "../../utils/Constants";
import { FetchFileIcon } from "../../utils/commonFunction";
import { buildAbsoluteDownloadUrl, download } from "../../utils/FileDownload";

export const RenderAttachList = (props) => {
  const openFile = (filePath) => {
    const finalURL = buildAbsoluteDownloadUrl(filePath);
    window.open(finalURL, "_blank");
  };
return (
  <div key={props?.i ?? ""} className="col-md-4 mb-4 file-box">
    <div className="uploded-files-item feed-pad">
      <div
        className="uploded-files-item-txt curser"
        data-toggle="tooltip"
        data-placement="right"
        onClick={() => {
          let fileURL;
          if (
            typeof props === "object" &&
            "fileUploadedFrom" in props &&
            String(props.fileUploadedFrom) === "1" &&
            !/^(?:https?:)?\/\//i.test(props.filePath)
          ) {
            fileURL = AWS_File_URL + props.filePath;
          } else {
            fileURL = props.filePath;
          }
          openFile(fileURL, props.fileName);
        }}
        title={props.fileName}
      >
        <figure>
          {props?.fileName && <i className={FetchFileIcon(props.fileName)}></i>}
        </figure>
        <figcaption>
          <h4 className="oneline-ellipsis">{props.fileName}</h4>
          <p>{props.size}</p>
        </figcaption>
      </div>

      {props.showClose ? (
        <button
          onClick={() => {
            props.removeF(props);
          }}
          type="button"
          className="btn file-remove-btn"
        >
          <i className="fal fa-times hold-show"></i>
        </button>
      ) : (
        <a
          onClick={(e) => {
            e.stopPropagation();
            let fileURL;
            if (
              typeof props === "object" &&
              "fileUploadedFrom" in props &&
              String(props.fileUploadedFrom) === "1" &&
              !/^(?:https?:)?\/\//i.test(props.filePath)
            ) {
              fileURL = AWS_File_URL + props.filePath;
            } else {
              fileURL = props.filePath;
            }
              fileURL = fileURL.replaceAll(" ", "%20");
              download(fileURL, props.fileName, fileURL.includes(AWS_File_URL) ? false : true);
          }}
          className="btn file-remove-btn rm-box-shadow download-icon"
        >
          <i className="fal fa-download download-icon"></i>
        </a>
      )}
    </div>
  </div>
);

}